import { Link } from 'wouter';
import { COMPANY } from '@/config';

export function LandingFooter() {
  return (
    <footer className="p-6 text-center border-t border-gray-800">
      <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400">
        <Link href="/privacy" className="hover:text-white transition-colors">
          Privacy Policy
        </Link>
        <Link href="/terms" className="hover:text-white transition-colors">
          Terms of Service
        </Link>
        <Link href="/data-deletion" className="hover:text-white transition-colors">
          Data Deletion
        </Link>
        <a href={`mailto:${COMPANY.supportEmail}`} className="hover:text-white transition-colors">
          Contact: {COMPANY.supportEmail}
        </a>
      </div>
      <p className="mt-4 text-xs text-gray-500">
        © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
      </p>
    </footer>
  );
}
